const categories = {
  food: { icon: 'restaurant', type: 'weekly', expense: -1 },
  'super market': { icon: 'shopping_cart', type: 'weekly', expense: -1 },
  fun: { icon: 'local_bar', type: 'weekly', expense: -1 },
  coffee: { icon: 'local_cafe', type: 'weekly', expense: -1 },
  transportation: { icon: 'directions_car', type: 'monthly', expense: -1 },
  shopping: { icon: 'shopping_basket', type: 'monthly', expense: -1 },
  bills: { icon: 'attach_money', type: 'monthly', expense: -1 },
  home: { icon: 'home', type: 'monthly', expense: -1 },
  gifts: { icon: 'card_giftcard', type: 'monthly', expense: -1 },
  travel: { icon: 'card_travel', type: 'yearly', expense: -1 },
  'yearly bills': { icon: 'monetization_on', type: 'yearly', expense: -1 },
  health: { icon: 'local_hospital', type: 'yearly', expense: -1 },
  education: { icon: 'school', type: 'yearly', expense: -1 },
  withdrawal: { icon: 'money_off', type: 'transfer' },
  deposit: { icon: 'local_atm', type: 'transfer' },
  transfer: { icon: 'compare_arrows', type: 'transfer' },
  work: { icon: 'work', type: 'income_yearly', income: 1 },
  salary: { icon: 'business', type: 'income_monthly', income: 1 },
  interest: { icon: 'account_balance', type: 'income_yearly', income: 1 },
  return: { icon: 'settings_backup_restore', type: 'income_yearly', title: "won't count as income", expense: 1 }
};

export default categories;
export const expenses = Object.keys(categories).filter(x => categories[x].expense);



// WEBPACK FOOTER //
// ./src/shared/categories.tsx